export default __webpack_public_path__ + "static/media/6.c8aa7c0f.png";